export default __webpack_public_path__ + "static/media/digital-ocean.86dc1947.svg";